import { ExperimentsAction, ExperimentAnalyticsTranslationState } from 'modules/experiments/types';
import { initialTranslationData } from 'modules/experiments/constants';
import { ActionTypes } from 'modules/experiments/ducks/actionTypes';

export const initialAnalyticsTranslationState: ExperimentAnalyticsTranslationState = {
  metricTranslations: {},
  translations: initialTranslationData,
};

export const experimentAnalyticsTranslationReducer = (
  state = initialAnalyticsTranslationState,
  action?: ExperimentsAction,
) => {
  switch (action?.type) {
    case ActionTypes.SET_I18N_TRANSLATIONS: {
      const { translations, metricResourceBundle } = action?.payload || {};
      return {
        ...state,
        metricTranslations: metricResourceBundle || state.metricTranslations,
        translations: translations || state.translations,
      };
    }

    default:
      return state;
  }
};
